import Luna from 'img/luna_refundable';
import { StyledSection } from './Section_Cooperation.style';
import { ROUTES } from 'utils/typings/routes';
import { Image, Headline, Row, Col, Button, Paragraph } from 'View/Common';

export const Section_Cooperations = () => {
  return (
    <StyledSection backgroundColor="c800">
      <Row>
        <Col xs={12} md={6} lg={5} className="text-wrapper order-2 order-md-1 offset-lg-1 offset-md-0">
          <Headline level={2}>Deine Krankenkasse zahlt!</Headline>
          <Paragraph>
            Verbessere deinen Schlaf mit 7Schläfer. Deine Krankenkasse übernimmt jetzt 75–100% der Kosten für unseren Präventionskurs. Jetzt
            prüfen, wie hoch deine Erstattung ist!
          </Paragraph>
          <Button target="_self" href={`${ROUTES.ZPP_LANDING_PAGE}#erstattungscheck-box`}>
            ZUM ERSTATTUNGSCHECK
          </Button>
        </Col>
        <Col xs={12} md={6} lg={5} className="luna-wrapper order-1 order-md-2">
          <Image image={Luna.src} srcSet={Luna.srcSet} alt="Luna schläft" className="luna-image" />
        </Col>
      </Row>
    </StyledSection>
  );
};
